module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyF.6cfc7b1a7176697fffaabd02e0c5476b.svg";